import { render } from "./TermsAndConditionsModal.vue?vue&type=template&id=1db4d691"
import script from "./TermsAndConditionsModal.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TermsAndConditionsModal.vue"]])

export default __exports__